var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDueSoonStatusIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8ZM8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM9 4C9 3.44772 8.55229 3 8 3C7.44772 3 7 3.44772 7 4V7.33726L6.99991 7.3883C6.9994 7.57821 6.99876 7.81735 7.05526 8.05268C7.10425 8.25675 7.18506 8.45184 7.29472 8.63078C7.42117 8.83714 7.59072 9.00578 7.72537 9.13971L7.76152 9.17574L9.79289 11.2071C10.1834 11.5976 10.8166 11.5976 11.2071 11.2071C11.5976 10.8166 11.5976 10.1834 11.2071 9.79289L9.17574 7.76152C9.08311 7.66889 9.03704 7.62249 9.005 7.58737L9.00258 7.58472L9.00241 7.58113C9.00024 7.53364 9 7.46826 9 7.33726V4Z",
    fill: "#C70009"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDueSoonStatusIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/due-soon-status-icon.23010e370135cff93108934482e82565.svg";